import { all, select, takeEvery, fork, call, put, delay } from 'redux-saga/effects'

// action

function* mainSaga() {
	// grid
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
